import React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PlusIcon, MinusIcon, Trash2Icon, ArrowRightIcon, ShoppingCartIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { Button } from '../components/ui/Button';
import { SmartImage } from '../components/common/SmartImage';
import { useI18n } from '../lib/i18n';
import { useCart } from '../lib/cart';
import { MACHINE } from '../lib/data';
export function Checkout() {
  const {
    t,
    lang
  } = useI18n();
  const navigate = useNavigate();
  const {
    machineId
  } = useParams();
  const {
    lines,
    add,
    decrement,
    removeLine,
    clear,
    total,
    typeCount,
    totalQty
  } = useCart();
  const id = machineId ?? MACHINE.id;
  if (lines.length === 0) {
    return <PageShell data-id="element-197" data-mp="o3eo57z667gr">
        <section className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-4 text-center" data-id="element-198" data-mp="o2wkhqa6gqyt">
          <ShoppingCartIcon className="h-14 w-14 text-silver/40" data-id="element-199" data-mp="37myfjknvfk5" />
          <p className="mt-4 text-lg text-silver/80" data-id="element-200" data-mp="37d5bn4bksa8">{t('empty_cart')}</p>
          <Link to={'/select/' + id} className="mt-6" data-id="element-201" data-mp="85ohw5m01gw5">
            <Button data-id="element-202" data-mp="cxg82f18tklr">{t('back_to_menu')}</Button>
          </Link>
        </section>
      </PageShell>;
  }
  return <PageShell data-id="element-203" data-mp="hx17eqkbruz0">
      <section className="mx-auto max-w-2xl px-4 py-8 sm:px-6" data-id="element-204" data-mp="hwsxn7ji15s1">
        <h1 className="text-2xl font-bold text-white" data-id="element-205" data-mp="3ge56teul3q0v">
          {t('review_your_order')}
        </h1>
        <p className="mt-1 text-sm text-silver/70" data-id="element-206" data-mp="3ld87yo7g1c3k">
          {t('machine')}: {id} ·{' '}
          {lang === 'en' ? MACHINE.location_en : MACHINE.location_am}
        </p>

        <div className="mt-6 space-y-3" data-id="element-207" data-mp="3qefj8x8sotez">
          {lines.map(line => {
          const name = lang === 'en' ? line.drink.name_en : line.drink.name_am;
          return <motion.div key={line.drink.id} layout className="glass-card flex items-center gap-4 p-3 sm:p-4" data-id="element-208" data-mp="15lkex3vjw3q1">
                <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-lg border border-[rgba(217,217,217,0.15)] bg-white/5" data-id="element-209" data-mp="36na8iohh3dr5">
                  <SmartImage src={line.drink.image} alt={name} className="h-full w-full object-contain p-1" data-id="element-210" data-mp="31oyue1k5ah34" />
                </div>
                <div className="min-w-0 flex-1" data-id="element-211" data-mp="3ao3vnfn3coiz">
                  <p className="truncate font-semibold text-white" data-id="element-212" data-mp="2n1dvkjuaz410">{name}</p>
                  <p className="text-sm text-silver/60" data-id="element-213" data-mp="2iz0nhos32u12">
                    {line.drink.volume} · {line.drink.price} ETB
                  </p>
                </div>
                <div className="flex items-center gap-2 rounded-lg border border-[rgba(255,113,1,0.4)] p-1" data-id="element-214" data-mp="2ws8k5uv0ufpm">
                  <button type="button" onClick={() => decrement(line.drink.id)} className="flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-[rgba(217,217,217,0.1)]" aria-label={`Decrease ${name}`} data-id="element-215" data-mp="2rxm4vgltk309">
                    <MinusIcon className="h-4 w-4" data-id="element-216" data-mp="jj7d8n6fueor" />
                  </button>
                  <span className="w-6 text-center font-semibold text-white" data-id="element-217" data-mp="jla75iaporyr">
                    {line.qty}
                  </span>
                  <button type="button" onClick={() => add(line.drink)} className="flex h-8 w-8 items-center justify-center rounded-md text-white hover:bg-[rgba(217,217,217,0.1)]" aria-label={`Increase ${name}`} data-id="element-218" data-mp="aqcfeejavl90">
                    <PlusIcon className="h-4 w-4" data-id="element-219" data-mp="ohh8syw2rhaw" />
                  </button>
                </div>
                <div className="w-20 text-right font-semibold text-white" data-id="element-220" data-mp="tgk966140zcj">
                  {line.qty * line.drink.price} ETB
                </div>
                <button type="button" onClick={() => removeLine(line.drink.id)} className="flex h-9 w-9 items-center justify-center rounded-md text-silver/60 hover:bg-[rgba(255,107,107,0.12)] hover:text-[#FF6B6B]" aria-label={`Remove ${name}`} data-id="element-221" data-mp="39b42vmg8jai7">
                  <Trash2Icon className="h-4 w-4" data-id="element-222" data-mp="3koe9699r5e50" />
                </button>
              </motion.div>;
        })}
        </div>

        <div className="glass-card mt-6 p-5" data-id="element-223" data-mp="3frxib7b64lo8">
          <div className="flex items-center justify-between text-sm text-silver/80" data-id="element-224" data-mp="gbhf5w830ix6">
            <span data-id="element-225" data-mp="c9ngfthg5ozn">
              {typeCount} {t('drink_types')} · {totalQty} {t('items')}
            </span>
            <span data-id="element-226" data-mp="79ro4ri43lzx">{t('subtotal')}</span>
          </div>
          <div className="mt-2 flex items-center justify-between border-t border-[rgba(217,217,217,0.12)] pt-3" data-id="element-227" data-mp="78galzyv6zvm">
            <span className="text-lg font-semibold text-white" data-id="element-228" data-mp="2dkfgqybzwea">
              {t('total')}
            </span>
            <span className="text-xl font-bold text-neon" data-id="element-229" data-mp="2n1f69gsgv9yo">{total} ETB</span>
          </div>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-between" data-id="element-230" data-mp="2cxi8c44n0h8w">
          <Button variant="secondary" onClick={clear} data-id="element-231" data-mp="2hwl5l2edlj6b">
            <Trash2Icon className="h-4 w-4" data-id="element-232" data-mp="2hxd3ijvg3szr" />
            {t('clear_cart')}
          </Button>
          <Button pulse onClick={() => navigate('/payment/' + id)} data-id="element-233" data-mp="2muwg7fchvxpl">
            {t('proceed_payment')}
            <ArrowRightIcon className="h-4 w-4" data-id="element-234" data-mp="2rn6d5fc11y1d" />
          </Button>
        </div>
      </section>
    </PageShell>;
}